import {useEffect, useState} from "react"

export const useGitDir = (orbitId?: string, repoId?: string) => {
  const [gitDir, setGitDir] = useState<string>()

  useEffect(() => {
    if (!orbitId || !repoId) {
      return
    }
    setGitDir(`/${orbitId}/${repoId}`)
  }, [orbitId, repoId])

  return gitDir
}
